// eslint-disable-next-line import/prefer-default-export
export const SortId = {
  AtoZ: 1,
  ZtoA: 2,
  Latest: 3,
  Newest: 4,
};
